var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWhatsapp = function SvgWhatsapp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 37 38"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#whatsapp_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.082.347C8.154.347.103 8.353.103 18.277a18.1 18.1 0 0 0 2.879 9.758c.375 1.168.083 2.502.083 2.502s-.667 3.753-1.043 5.046c-.292 1.084.167 1.46.334 1.543.167.166.626.417 1.502-.042 1.21-.584 4.797-1.918 4.797-1.918s1.21-.5 2.42-.375a18 18 0 0 0 7.05 1.417c9.927 0 17.978-8.048 17.978-17.972S28.011.346 18.083.346m8.177 24.477c-1.169 1.418-2.378 2.419-5.006 1.793-5.465-2.251-9.22-6.046-11.514-11.509-.584-2.585.376-3.836 1.794-5.004.459-.375 1.001-.333 1.502-.375a1.36 1.36 0 0 1 1.418 1l.918 3.212c.167.583-.042 1.126-.5 1.5l-.751.543c-.126.125-.167.292-.084.459 1.252 2.126 3.796 4.67 5.924 5.921.166.083.333.042.458-.083l.543-.751a1.37 1.37 0 0 1 1.502-.5l3.211.917a1.36 1.36 0 0 1 1.002 1.418c-.084.5-.042 1.042-.417 1.46",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "whatsapp_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.103.347h36v37h-36z"
  })))));
};
export default SvgWhatsapp;